export * from "./alignment";
export * from "./layout";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/pdf-lib/es/api/text/index.js
// module id = 2055
// module chunks = 0